import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';


class Holiday2022 extends React.Component {

	static propTypes = {
		location: PropTypes.object
	};

	static contextTypes = {
		store: PropTypes.any,
		router: React.PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);

		const firstEntry = [{display: 'Location*', 'value': ''}];
		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesignerLocation: null,
		};
	}

	componentDidMount() {
		// this.giftsNav();
	}

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	openIntercom() {
    acquireIO.max();
  }

	getLocationDesigners() {
		return [];
	}

	changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	changeDesigner(evt) {
		this.setState({ inputDesigner: evt.target.value });
	}

	changeDesignerLocation(evt) {
		this.setState({ designerLocation: evt.target.value });
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

  getShowDates(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.dates;
  		}
  	}
  	return '';
  }

  getShowLink(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.page;
  		}
  	}
  	return '';
  }

  designerNav(page) {
  	if(!page) { return; }
  	this.internalNav(page);
  }

  giftsNav(page) {
  	window.location.href='https://gifts.diamondsdirect.com';
  }

	render() {

		return <div className='Holiday2022'>

			<div className='headerSection'>
				<div className='headerSectionWrapper'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/header.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/header_m.jpg' />
					<button type='button' className='shopButton' onClick={() => this.internalNav('gallery/engagement-rings')} style={{ display: 'none' }}>Shop Now</button>
				</div>
			</div>

			<div className='shopSection' style={{ display: 'none' }}>
				<div className='shopButtonWrapper'>
					<button type='button' className='shopButton'>Shop Online Now</button>
				</div>
				<div className='shopTilesWrapper'>
					<div className='shopTile' onClick={() => this.internalNav('gallery/wedding-bands/womens')}>
						<div className='shopImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/studs.jpg' />
						</div>
						<div className='shopTileButton'><div>Shop Wedding Bands</div></div>
					</div>
					<div className='shopTile' onClick={() => this.internalNav('gallery/engagement-rings?mode=setting')}>
						<div className='shopImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/engagement.jpg' />
						</div>
						<div className='shopTileButton'><div>Shop Engagement</div></div>
					</div>
					<div className='shopTile' onClick={() => this.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet')}>
						<div className='shopImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/pendants.jpg' />
						</div>
						<div className='shopTileButton'><div>Shop Fashion</div></div>
					</div>
				</div>
			</div>

			<div className='titleSection'>
				<div className='mainTitle' style={{ display: 'none' }}>VISIT US IN STORE</div>
				<div className='iconLineWrapper' style={{ display: 'none' }}>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/summer2022/iconline.svg' />
				</div>
				<div className='titleP'>To help you celebrate with the ones you love most this year, we're putting together some <strong>amazing surprises!</strong></div>
				<div className='titleP'>Check in with us online or in-store to take advantage of:</div>
				<div className='titleBox'>
					<div className='titleBoxLiner'>
						<div className='titleBig'>0% APR for 3 Years<sup>*</sup></div>
						<div className='titleDisclaimer'>Subject to credit approval.</div>
						<div className='titleDates'>Available Now - Dec. 31</div>
						<div className='titleAction' onClick={() => this.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826')}>Ready to Apply</div>
					</div>
				</div>
			</div>

			<div className='topSection' style={{ display: 'none' }}>
				
				<div className='topRow'>

					<div className={'topRowRight copyBlock'}>
						<div className='topDates'>Nov. 11 - 13</div>
						<div className='topDatesHr'></div>
						<div className='topDateColumnWrapper'>
							<div className='topDateColumn'>
								<Link to={'/austin'} className='storeLink'>Austin,&nbsp;TX</Link>
								<Link to={'/oklahoma-city'} className='storeLink'>Oklahoma&nbsp;City,&nbsp;OK</Link>
								<Link to={'/san-antonio'} className='storeLink'>San&nbsp;Antonio,&nbsp;TX</Link>
								<Link to={'/kansas-city'} className='storeLink'>Kansas&nbsp;City,&nbsp;KS</Link>
								<Link to={'/tysons'} className='storeLink'>Tysons,&nbsp;VA</Link>
								<Link to={'/charleston'} className='storeLink'>Charleston,&nbsp;SC</Link>
							</div>
							<div className='topDateColumn'>
								<Link to={'/virginia-beach'} className='storeLink'>Virginia&nbsp;Beach,&nbsp;VA</Link>
								<Link to={'/indianapolis'} className='storeLink'>Indianapolis,&nbsp;IN</Link>
								<Link to={'/columbus'} className='storeLink'>Columbus,&nbsp;OH</Link>
								<Link to={'/new-orleans'} className='storeLink'>New&nbsp;Orleans,&nbsp;LA</Link>
								<Link to={'/troy'} className='storeLink'>Troy,&nbsp;MI</Link>
							</div>
							<div className='topDateVr'></div>
						</div>
					</div>
					<div className={'topRowLeft copyBlock'}>
						<div className='topDates'>Nov. 18 - 20</div>
						<div className='topDatesHr'></div>
						<div className='topDateColumnWrapper'>
							<div className='topDateColumn'>
								<Link to={'/charlotte'} className='storeLink'>Charlotte,&nbsp;NC</Link>
								<Link to={'/raleigh'} className='storeLink'>Raleigh,&nbsp;NC</Link>
								<Link to={'/dallas'} className='storeLink'>Dallas,&nbsp;TX</Link>
								<Link to={'/frisco'} className='storeLink'>Frisco,&nbsp;TX</Link>
								<Link to={'/cleveland'} className='storeLink'>Cleveland,&nbsp;OH</Link>
								<Link to={'/houston'} className='storeLink'>Houston,&nbsp;TX</Link>
								<Link to={'/pittsburgh'} className='storeLink'>Pittsburgh,&nbsp;PA</Link>
							</div>
							<div className='topDateColumn'>
								<Link to={'/birmingham'} className='storeLink'>Birmingham,&nbsp;AL</Link>
								<Link to={'/richmond'} className='storeLink'>Richmond,&nbsp;VA</Link>
								<Link to={'/st-louis'} className='storeLink'>St.&nbsp;Louis,&nbsp;MO</Link>
								<Link to={'/boca-raton'} className='storeLink'>Boca&nbsp;Raton,&nbsp;FL</Link>
								<Link to={'/baybrook'} className='storeLink'>Baybrook,&nbsp;TX</Link>
								<Link to={'/greenville'} className='storeLink'>Greenville,&nbsp;SC</Link>
								<Link to={'/jacksonville'} className='storeLink'>Jacksonville,&nbsp;FL*</Link>
							</div>
							<div className='topDateVr'></div>
						</div>
					</div>
				</div>
			</div>

			

			<div className='midSection' style={{ display: 'none' }}>
				<div className='midP'>Missed your local showroom’s event? Enjoy 20% savings online now!</div>
			</div>

			<div className='looksSection'>
				<div className='looksWrapper'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/editorial.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/editorial_m.jpg' />
					<Link to={'/jewelry/EHOOP05010'} className={'lb lb1'}></Link>
					<Link to={'/jewelry/TB10000257'} className={'lb lb2'}></Link>
					<Link to={'/band/B14MS03511'} className={'lb lb3'}></Link>
					<Link to={'/setting/SMD1450920'} className={'lb lb4'}></Link>
					<Link to={'/band/BLDSM17257'} className={'lb lb5'}></Link>
					<Link to={'/jewelry/NCOST08045'} className={'lb lb6'}></Link>
				</div>
			</div>

			<div className='formSection'>		
				<div className='formBoxWrapper'>
					<div className='formInnerWrapper'>
						<div className='formP'>Walk-in visits are always welcome! But if you'd prefer to set up an appointment online or in-store, please use the form below and we will follow up to confirm!</div>
						<div className='formWrapper'>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorName ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Full Name*'
									value={this.state.inputName}
                	onChange={::this.changeName} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorEmail ? 'textInput error' : 'textInput'}
									type='email' 
									placeholder='Email Address*'
									value={this.state.inputEmail}
                	onChange={::this.changeEmail} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorPhone ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Telephone'
									value={this.state.inputPhone}
                	onChange={::this.changePhone} />
							</div>
							<div className='formInputWrapper'>
								<RhinoSelect
	                selectClass={'summerSelect'}
	                required={true}
	                value={this.state.inputLocation}
	                options={this.state.locations}
	                changeMethod={(evt) => this.changeLocation(evt)}
	                error={this.state.errorLocation !== null} />
							</div>
							<div className='formActionRow'>
								<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className='ggSection'>
				<div className='ggTitle'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/defi_gg.svg' />
				</div>
				<div className='ggLine'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/gg_iconline.svg' />
				</div>
				<div className='ggP'>Diamonds Direct invites you to enjoy this holiday season with a little extra sparkle! From now until the ball drops we’ll be toasting to the best part of the year.</div>
				<div className='ggP'>Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!</div>
				<div className='ggButton' onClick={::this.giftsNav}>Shop Holiday Gifts</div>

				<div className='ggItemRow'>
					<Link to={'/jewelry/BLDLG15656'} className={'ggItem'}>
						<div className={'ggItemImg ggItemImg1'}></div>
						<div className={'ggItemLabel'}>Three Row Diamond Stackable Ring</div>
					</Link>
					<Link to={'/jewelry/PRLFE01094'} className={'ggItem'}>
						<div className={'ggItemImg ggItemImg2'}></div>
						<div className={'ggItemLabel'}>Double Halo Pearl and Diamond Stud Earrings</div>
					</Link>
					<Link to={'/jewelry/NFANC29328'} className={'ggItem'}>
						<div className={'ggItemImg ggItemImg3'}></div>
						<div className={'ggItemLabel'}>Baguette Circle Diamond Pendant</div>
					</Link>
					<Link to={'/jewelry/EMER03342'} className={'ggItem'}>
						<div className={'ggItemImg ggItemImg4'}></div>
						<div className={'ggItemLabel'}>Emerald and Mixed Diamond Halo Ring</div>
					</Link>
				</div>
			</div>

			<div className='legalSection' style={{ display: 'none' }}>
				<div className='legalInnerWrapper'>*Discount excludes GIA certified diamonds and price-protected designer lines. Cannot be combined with other offers. Inquire for details.</div>
			</div>
			
		</div>;
	}
}
export default Holiday2022;

function mapStateToProps(state) {
  return {

  };
}

export const Holiday2022Container = connect(
  mapStateToProps,
  allActionCreators
)(Holiday2022);


// WEBPACK FOOTER //
// ./src/components/views/promopages/holiday2022/Holiday2022.jsx